import { createContext } from 'react'

export type ToastTone = 'neutral' | 'positive' | 'critical'

export interface Toast {
  id: string
  message: string
  tone: ToastTone
}

export interface ToastContextValue {
  /** Mostra un messaggio effimero. Ritorna l'id, se serve chiuderlo prima. */
  notify: (message: string, tone?: ToastTone) => string
  dismiss: (id: string) => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)
